import { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { CartContext } from "./cartcontext";

const CartIcon = () => {
  const { cart, total } = useContext(CartContext);
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const navigate = useNavigate();

  const itemCount = cart.reduce((sum, item) => sum + item.qty, 0);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeCart = () => setOpen(false);

  const goToCheckout = () => {
    closeCart();
    navigate("/cart");
  };

  const cartPanel = (
    <>
      {open && isMobile && (
        <>
          <button
            type="button"
            aria-label="Cerrar carrito"
            className="cart-backdrop"
            onClick={closeCart}
          />

          <aside className="cart-mobile-drawer" aria-label="Carrito de compras">
            <h4>Tu carrito</h4>

            {cart.length === 0 ? (
              <p>No hay productos</p>
            ) : (
              <>
                {cart.map((item) => (
                  <div key={item.name} className="cart-mini-item">
                    <strong>{item.name}</strong>
                    <div>
                      {item.qty} × ${Number(item.price).toFixed(2)}
                    </div>
                  </div>
                ))}

                <hr />
                <h5>Total: ${total.toFixed(2)}</h5>

                <button
                  type="button"
                  className="checkout-btn"
                  onClick={goToCheckout}
                >
                  Checkout
                </button>
              </>
            )}

            <button type="button" className="cart-close-btn" onClick={closeCart}>
              Cerrar
            </button>
          </aside>
        </>
      )}

      {open && !isMobile && (
        <aside className="cart-desktop-dropdown" aria-label="Carrito de compras">
          {cart.length === 0 ? (
            <p>No hay productos</p>
          ) : (
            <>
              {cart.map((item) => (
                <div key={item.name} className="cart-mini-item">
                  <strong>{item.name}</strong>
                  <div>
                    {item.qty} × ${Number(item.price).toFixed(2)}
                  </div>
                </div>
              ))}

              <hr />
              <h5>Total: ${total.toFixed(2)}</h5>

              <button
                type="button"
                className="checkout-btn"
                onClick={goToCheckout}
              >
                Checkout
              </button>
            </>
          )}
        </aside>
      )}
    </>
  );

  return (
    <>
      <button
        type="button"
        className="floating-cart-btn"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Abrir carrito"
      >
        🛒 {itemCount}
      </button>

      {createPortal(cartPanel, document.body)}
    </>
  );
};

export default CartIcon;
